function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 299.09,
  y1: -232.12,
  x2: 254.91,
  y2: -238.88,
  gradientTransform: "matrix(1, 0, 0, -1, -257, -215.5)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ec5f24"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f8995c"
})));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "url(#linear-gradient)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M23,18.5h1.59a1,1,0,0,1,.7,1.71L20.7,24.8a1,1,0,0,1-1.41,0L14.7,20.21a1,1,0,0,1,.71-1.71H17v-5a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1Zm-9,11a1,1,0,0,1,0-2H26a1,1,0,0,1,0,2Z",
  fill: "#fff",
  fillRule: "evenodd"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M24,7h0a4,4,0,0,1,4,4h0a4,4,0,0,1-4,4h0a4,4,0,0,1-4-4h0A4,4,0,0,1,24,7Z",
  fill: "#f8b219"
});

var SvgDownload = function SvgDownload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/download.86564a76.svg";
export { ForwardRef as ReactComponent };